/**
 * WHAT CARRIES THE BOX WHEN NO SHIP DOES (SCHED-39, Евгений 08.10). The API serves `vessel: null` and
 * `mode: rail | truck | barge | inland` on a leg like `TRUCK TBA`; the type of transport is the answer
 * there, so a sailing with no ship's name whose every leg is such a conveyance is labelled by it
 * ("Rail") rather than by "—" or "TBN". Null when any leg is (or may be) at sea: then no ship is given.
 */
const LABEL: Record<string, string> = {
  rail: 'Rail',
  truck: 'Truck',
  barge: 'Barge',
  inland: 'Inland',
}

export function conveyanceLabel(
  legs: readonly { mode?: string | null }[] | null | undefined
): string | null {
  if (!legs || legs.length === 0) return null
  const labels = legs.map((l) => (l.mode ? LABEL[l.mode] : undefined))
  if (labels.some((x) => x === undefined)) return null
  return labels[0] ?? null
}
